import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>RESEARCH AND DEVLOPMENT</h2>
                        <div class="clearfix"></div>
                        <p>
                          R&D forms the backbone of IDPL, aiding it to keep
                          abreast with the modern technologies of the world and
                          enabling it to build self-reliance to meet the health
                          needs of India.
                        </p>
                        <p>
                          A measure of its success lies in the production of
                          Vitamin B6 for the first time in the country based
                          exclusively on IDPL’s technology. In-house R&D had
                          also succeeded in developing and implementing
                          technologies for production of Methyl Dopa and
                          Chloroquine Phosphate.
                        </p>
                        <p>
                          Three novel compounds, having promising therapeutic
                          value, are in advanced stage of biological evaluation.
                          A non-steroidal, anti-inflammatory and anti-arthritic
                          compound has completed Phase-III clinical trials.
                        </p>
                        <p>
                          In addition, IDPL has presently a Formulations
                          Development Research Laboratory at Rishikesh plant. A
                          number of company’s formulations have been developed
                          through in-house formulations development research.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
